import { writable } from 'svelte/store';
import watchMedia from "svelte-media";

function createCategoryStore() {
    const initialState = { loading: false, categories: [], error: null };
	const { subscribe, set } = writable(initialState);

	return {
		subscribe,
		requestCategories: () => set({...initialState, loading: true}),
		receiveCategories: (categoryResponse) => set({...initialState, categories: categoryResponse.results}),
		error: (error) => set({...initialState, error})
	};
}

function createProductStore() {
    const initialState = { loading: false, pages: 1, products: [], filters: { page: 1, category: null, search: null }, error: null };
	const { subscribe, set, update } = writable(initialState);

	return {
		subscribe,
		requestProducts: ({ page, category, search }) => set({...initialState, loading: true, filters: { page, category, search }}),
		receiveProducts: (productResponse) => update(state => {
			state.loading = false;
			state.pages = productResponse.pages;
			state.products = productResponse.results;

			return state;
		}),
		error: (error) => set({...initialState, error})
	};
}

function createProductDownloadStore() {
    const initialState = { loading: false, productId: null, error: null };
	const { subscribe, set } = writable(initialState);

	return {
		subscribe,
		requestProductDownload: (productId) => set({...initialState, productId, loading: true }),
		receiveProductDownload: (productId) => set({...initialState, productId }),
		error: (productId, error) => set({...initialState, productId, error })
	};
}

export const categoryStore = createCategoryStore();

export const productStore = createProductStore();

export const productDownloadStore = createProductDownloadStore();

export const media = watchMedia({ desktopView: '(min-width: 992px)' });
